// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<div style="height: 100%">
  <v-toolbar dark dense class="obspanel-toolbar">
    <v-btn icon to="/p/users/profile">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
  </v-toolbar>

<v-container fluid style="height: 100%">
  <v-card>
    <v-card-title primary-title>
      <div>
        <h3 class="text-h5 mb-0">Update User Information</h3>
      </div>
    </v-card-title>
    <v-progress-circular v-if="updateUserInfoInProgress" indeterminate v-bind:size="50" style="position: absolute; left: 0; right: 0; margin-left: auto; margin-right: auto; margin-top: 60px;"></v-progress-circular>
    <v-card-text>
      <form action="">
        <v-row justify="space-between">
          <v-col><v-text-field name="first-name" label="First Name" autocomplete="given-name" v-model="firstName" type="text"></v-text-field></v-col>
          <v-col><v-text-field name="last-name" label="Last Name" autocomplete="family-name" v-model="lastName" type="text"></v-text-field></v-col>
        </v-row>
      </form>
      <v-alert error v-model="showUserUpdateInfoErrorAlert">{{ updateUserInfoErrorAlert }}</v-alert>
      <v-row justify="space-around">
        <v-btn @click.stop.native="updateUserInfo()">Send</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</v-container>

</div>
</template>

<script>
import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      updateUserInfoInProgress: false,
      updateUserInfoErrorAlert: '',
      firstName: '',
      lastName: '',

      rules: {
        email: (value) => {
          if (value === '') {
            return true
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  methods: {
    clearUserUpdateErrorAlert: function () {
      this.userUpdateErrorAlert = ''
    },
    updateUserInfo: function () {
      var that = this
      this.updateUserInfoInProgress = true
      NoctuaSkyClient.users.updateUserInfo({ first_name: this.firstName, last_name: this.lastName }).then(res => {
        that.back()
        that.updateUserInfoInProgress = false
      }).catch(function (res) {
        that.updateUserInfoInProgress = false
        if (res.message) {
          that.updateUserInfoErrorAlert = res.message
        } else if (res.errors) {
          that.updateUserInfoErrorAlert = ''
          for (const k in res.errors) {
            that.updateUserInfoErrorAlert += k + ': ' + res.errors[k] + '\n'
          }
        }
      })
    }
  },
  mounted: function () {
    this.firstName = this.$store.state.noctuaSky.user.first_name
    this.lastName = this.$store.state.noctuaSky.user.last_name
  },
  computed: {
    showUserUpdateInfoErrorAlert: function () {
      return this.updateUserInfoErrorAlert !== ''
    }
  }
}
</script>

<style>
</style>
